export const SIGN_UP_TEST_IDS = {
  submitButton: 'auth-sign-up-submit',
} as const;
